import { render, staticRenderFns } from "./IPInfo.vue?vue&type=template&id=55871f8a&scoped=true&"
import script from "./IPInfo.vue?vue&type=script&lang=js&"
export * from "./IPInfo.vue?vue&type=script&lang=js&"
import style0 from "./IPInfo.vue?vue&type=style&index=0&id=55871f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55871f8a",
  null
  
)

export default component.exports